var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout"},[_c('page-header',{on:{"SearchChange":_vm.SearchChange}}),_c('div',{staticClass:"page-content"},[_c('article-list',{ref:"al"})],1),(_vm.noMoreData)?_c('page-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }